import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const addOnboardingService = async (onboardingData: any) =>
  handleApiCall(() => ApiService.post(apiRoutes.onboarding, onboardingData));

export const getOnboardingService = async (query: any) =>
  handleApiCall(() =>
    ApiService.get(apiRoutes.onboarding.replace(":query", query))
  );

export const getOnboardingByIdService = async (id: string) =>
  handleApiCall(() =>
    ApiService.get(apiRoutes.onboardingById.replace(":id", id))
  );

export const deleteOnboardingByIdService = async (id: string) =>
  handleApiCall(() =>
    ApiService.delete(apiRoutes.onboardingById.replace(":id", id))
  );

export const editOnboardingService = async (
  id: string,
  onboardingData: FormData
) =>
  handleApiCall(() =>
    ApiService.put(apiRoutes.onboardingById.replace(":id", id), onboardingData)
  );
